module.exports = __webpack_public_path__ + "static/pandesal-treats-65b2faa8e07da90f3e93b084523e6f60.jpg";